import React from "react";
import { useTranslation } from "react-i18next";

import { getDisplayedAmount } from "@utils";
import { AccStatementBetSlipEventInOffer } from "@data-types/account-statement/AccountStatementBetSlip";

export function HandlingFeePercentage(props: {
	slipDetails: AccStatementBetSlipEventInOffer;
}) {
	const t = useTranslation().t;

	if (
		!props.slipDetails.handlingFeePercentage ||
		!props.slipDetails.handlingFee
	) {
		return null;
	}

	return (
		<tr className="table--bets__tr">
			<td className="table--bets__dd">
				{t<string>(
					"ACC_STATEMENT.BET_DETAILS.ADDITIONAL_HANDLING_FEE",
					{
						0: props.slipDetails.handlingFeePercentage.toFixed(),
					}
				)}
			</td>
			<td className="table--bets__dd">
				{getDisplayedAmount(props.slipDetails.handlingFee)}
			</td>
		</tr>
	);
}
